import LoginContainer from "./containers/LoginContainer"
import {UserIsNotAuthenticated} from '../AuthWrappers'

export default {
  path: '/login',
  component: UserIsNotAuthenticated(LoginContainer)
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js